export default {
  LOADING: 'LOADING',
  SIDE_LOAD_DRIVE: 'SIDE_LOAD_DRIVE',
  LOAD_DRIVE_SUCCESS: 'LOAD_DRIVE_SUCCESS',
  LOAD_DRIVE_FAILURE: 'LOAD_DRIVE_FAILURE',
  SET_ACTIVE_MENU: 'SET_ACTIVE_MENU'
}